module.exports = __webpack_public_path__ + "static/media/starship-freighter.4a6231fc.svg";